import { Card } from "ui/components/card";
import { Separator } from "ui/components/separator";
import { Icon } from "components";

// Same look as EvtIntegrationInputCard, but a navigation card: no create button,
// the footer just names what's inside and the whole card is clickable.
export default function IntegrationCard({ title, icon, label, onClick }) {
  return (
    <Card
      onClick={onClick}
      role="link"
      tabIndex={0}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onClick?.()}
      className="h-max gap-0 py-1 border shadow-sm cursor-pointer transition-colors hover:bg-muted/40"
    >
      <div className="p-4 md:p-6 space-y-4">
        <div className="text-foreground">
          <Icon icon={icon} className="size-10" />
        </div>
        <h3 className="text-lg font-semibold">{title}</h3>
      </div>
      <Separator />
      <div className="px-4 md:px-6 py-4 flex justify-between items-center text-sm text-muted-foreground">
        {label}
        <Icon icon="lucide:arrow-right" className="size-4" />
      </div>
    </Card>
  );
}
